import styled from 'styled-components';

export const StyledTable = styled.div`
  display: table;
  border: 1px solid ${({ theme }) => theme.colors.heavyLineOutline};
  border-radius: 5px;
`;

export const StyledHeaderRow = styled.div`
  display: table-row;
`;

export const StyledHeading = styled.div`
  display: table-cell;
  padding: 16px;
  text-align: left;
  color: ${({ theme }) => theme.colors.secondaryText};
`;
